module.exports = __webpack_public_path__ + "media/images/nrf/nrf2-a424a6b9e33c43a76d0400e68e5310bc.png";